export const blockIconsSocialDiversity1New = (
	<span className='material-symbols-outlined'>diversity_1</span>
);
